import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { commonStyles } from '../../helpers/commonStyles';
import { Base } from '../Base';
import { cardMediaStyles } from './CardMedia.styles';
import { cardMediaTheme } from './CardMedia.stylex';
export const CardMedia = createPolymorphicComponent(forwardRef(function CardMedia(props, forwardedRef) {
    const { styles, sx, children, src, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'CardMedia',
        styles: [cardMediaStyles, styles],
    });
    return (_jsx(Base, { role: 'img', ...other, sx: [
            cardMediaTheme,
            globalStyles,
            combineStyles('host', 'host$image', !!src && commonStyles.backgroundImage(src)),
            sx,
        ], ref: forwardedRef, children: children }));
}));
